// extracted by mini-css-extract-plugin
export default {"text":"TypingText_text__WpTM8","question":"TypingText_question__gqsWd","answer":"TypingText_answer__pm27E"};